import { AjaxListener } from "../core/AjaxListener.js";

class Preloader extends AjaxListener {
    constructor(preloaderContainer = document.querySelector("body"), ajaxListener = false) {
        super();
        this.preloaderContainer = preloaderContainer;
        this.ajaxListener = ajaxListener;

        // Inicjalizacja
        this.init();
    }

    // W przypadku tej statycznej metody, preloader jest dynamicznie tworzony jako dziecko elementu body.
    static show() {
        document.querySelector("body").insertAdjacentHTML(
            "beforeend",
            (function () {
                return `
                <div id="preloader" class="preloader">
                    <div class="preloader__spinner spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>`;
            })()
        );

        document.getElementById("preloader").classList.add("preloader--active");
    }

    //
    static hide() {
        (async function () {
            let result = await new Promise((resolve, reject) => {
                document.getElementById("preloader").classList.remove("preloader--active");
                setTimeout(() => {
                    resolve(true);
                }, 300);
            });

            if (result) {
                document.getElementById("preloader").remove();
            }
        })();
    }

    getPreloaderContainerElement() {
        if (typeof this.preloaderContainer === "object") {
            return this.preloaderContainer;
        } else if (typeof this.preloaderContainer === "string") {
            return document.querySelector(this.preloaderContainer);
        }
    }

    show() {
        this.getPreloaderContainerElement().insertAdjacentHTML(
            "beforeend",
            (function () {
                return `
                <div id="preloader" class="preloader">
                    <div class="preloader__spinner spinner-border text-primary" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>`;
            })()
        );

        this.getPreloaderContainerElement().querySelector(".preloader").classList.add("preloader--active");
    }

    hide() {
        (async () => {
            let result = await new Promise((resolve, reject) => {
                this.getPreloaderContainerElement().querySelector(".preloader").classList.remove("preloader--active");
                setTimeout(() => {
                    resolve(true);
                }, 300);
            });

            if (result) {
                this.getPreloaderContainerElement().querySelector(".preloader").remove();
            }
        })();
    }

    init() {
        // Jeśli true to inicjalizujemy procedury obsługi zdarzeń oraz przypisujemy funkcje.
        if (this.ajaxListener) {
            this.ajaxEvents();

            // Funkcja zostanie wykonanana gdy rozpocznie się pierwsze żądanie Ajax.
            this.ajaxStartFunction = this.show;

            // Funkcja zostanie wykonanana po zakończeniu wszystkich żądań Ajax.
            this.ajaxStopFunction = this.hide;
        }

        this.getPreloaderContainerElement();
    }
}

export { Preloader };
